module.exports = __webpack_public_path__ + "img/auto-w.21037196.svg";